import http from "@/http-common";

class CrudDataService {
  getAll(table_name) {
    return http.get(`/${table_name}`);
  }

  get(table_name, id) {
    return http.get(`/${table_name}/${id}`);
  }

  create(table_name, data, headers) {
    return http.post(`/${table_name}`, data, headers);
  }
}

export default new CrudDataService();
